<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <v-row justify="space-between">
      <v-col cols="12" md="3">
        <h2>
          Izvoz aktivnih blagajn - excel:
        </h2>
      </v-col>
    </v-row>
    <v-row v-if="!searching">
      <v-col cols="3" md="3">
        <DateSelector
          label="Od"
          :date="startDate"
          @change="updateStartDate"
        />
      </v-col>
      <v-col cols="3" md="3">
        <DateSelector
          label="Do"
          :date="endDate"
          @change="updateEndDate"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text mr-2"
          @click="search"
        >
          Išči
          <v-icon right dark>fas fa-search</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
        <v-btn
          :disabled="!base64pdf"
          color="#0F998E"
          class="white--text mr-2"
          @click="save"
        >
          Shrani
          <v-icon right dark>mdi-content-save-outline</v-icon>
        </v-btn>
        <div class="mb-2 d-md-none"></div>
      </v-col>
    </v-row>
    <v-row v-else>
      <app-spinner>Pridobivanje podatkov..</app-spinner>
    </v-row>
  </div>
</template>

<script>
import printJS from 'print-js'
import moment from 'moment'
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import DateSelector from '../components/DateSelector.vue'
import AppSpinner from '../components/AppSpinner.vue'

export default {
  props: ['id'],
  mixins: [
    asyncDataStatus
  ],
  components: {
    DateSelector,
    AppSpinner
  },
  data () {
    return {
      base64pdf: null,
      fileName: '',
      startDate: null,
      endDate: null,
      searching: false,
    }
  },
  methods: {
    ...mapActions('companies', ['getElectronicDeviceListForDealer']),
    print () {
      printJS({ printable: this.base64pdf, type: 'pdf', base64: true })
    },
    save () {
      const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.base64pdf}`
      const downloadLink = document.createElement('a')

      downloadLink.href = linkSource
      downloadLink.download = this.fileName
      downloadLink.click()
    },
    send () {

    },
    updateStartDate ({ date }) {
      this.startDate = date
    },
    updateEndDate ({ date }) {
      this.endDate = date
    },
    search () {
      this.searching = true
      this.getElectronicDeviceListForDealer({ startDate: this.startDate, endDate: this.endDate })
      .then(response => {
        const responseItems = response.data.items[0]
        this.asyncDataStatus_fetched()
        this.base64pdf = responseItems.data
        this.fileName = responseItems.filename
        this.searching = false
        // console.log(this.base64pdf)
      })
      .catch(anErr => {
        console.log(anErr)
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri liste prevzemnic.'
        })
      })
    },
    closeWindow () {
      window.close()
    }
  },
  created () {
    this.asyncDataStatus_fetched()
    this.startDate = moment().format('YYYY-MM-DD')
    this.endDate = moment().format('YYYY-MM-DD')
    /* this.getElectronicDeviceListForDealer({ startDate: this.startDate, endDate: this.endDate })
      .then(response => {
        const responseItems = response.data.items[0]
        this.asyncDataStatus_fetched()
        this.base64pdf = responseItems.data
        this.fileName = responseItems.filename
      })
      .catch(anErr => {
        console.log(anErr)
        this.$notify({
          type: 'error',
          text: 'Prišlo je do napake pri liste prevzemnic.'
        })
      }) */
  }
}
</script>

<style scoped>
.pdf-preview {
  border: 1px solid black;
}
</style>
